"use client";
import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Link from "next/link";

gsap.registerPlugin(ScrollTrigger);

const thirrdparty_images = [
    {
        title: "- Head of Sales",
        description: "Primalt delivered a fully functional app and CRM, exceeding the client's expectations. The team was responsive and attentive to the client's needs, providing the project three months ahead of schedule. Their in-depth research and ability to offer customized solutions were commendable.",
        link: "https://clutch.co/profile/primalt#reviews"
    },
    {
        title: "- Founder",
        description: "Primalt's work resulted in positive ROI, partner satisfaction, and meeting and improving upon the client's requests. The team delivered everything on time, did detailed market research, and communicated via in-person and virtual meetings, emails, and messages. Their dedication was outstanding. ",
        link: "https://clutch.co/profile/primalt#reviews"
    },
    {
        title: "- Head of Technical Team",
        description: "Primalt delivered an outstanding experience with the Pluggo app, combining professionalism with a proactive mindset. Instead of simply following the brief, they proposed superior solutions that exceeded my expectations in both design and functionality. Working with them felt like a true partnership dedicated to high-quality results.",
        link: "https://www.goodfirms.co/company/primalt"
    },
    {
        title: "- Lead Architect",
        description: "The custom CRM developed for us has completely overhauled how we track project lifecycles and client communications. Coupled with a sleek, high-performing website that perfectly showcases our portfolio, they’ve helped us achieve a level of operational streamlining we didn't think was possible for a design firm.",
        link: "https://clutch.co/profile/primalt#reviews"
    },
];

export default function ClientsTestimonials() {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const items = containerRef.current?.querySelectorAll(".party-item");
        if (items) {
            items.forEach((el) => {
                gsap.from(el, {
                    opacity: 0,
                    y: 50,
                    duration: 1,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: el,
                        start: "top 80%",
                    },
                });
            });
        }
    }, []);

    return (
        <div className="container mx-auto mb-12 mt-6 px-4 max-w-6xl">
            <div className="grid md:grid-cols-4 gap-8">
                {thirrdparty_images?.map((item, i) => (
                    <Link href={item?.link} target='_blank' className="party-item bg-gradient-to-br flex flex-col justify-between from-black-50/70 to-purple-900/50 border border-purple-900 p-6 rounded-lg shadow hover:shadow-lg transition hover:opacity-80">
                        <p className="text-sm md:text-md mb-6 text-start">
                            {item?.description}
                        </p>
                        <p className="text-md md:text-[16px] mb-0 mt-auto text-end">
                            {item?.title}
                        </p>
                    </Link>
                ))}
            </div>
        </div>
    );
}
